const fixedHeader = document.querySelectorAll(".fixed-header");

if (fixedHeader.length) {
    import("./modules/anchor-fixed-header.min.js")
        .then(
            anchorFixedHeader => {
                anchorFixedHeader.initAnchorFixedHeader();
            }
        );
}